import getAgentLoggedId from 'utils/pivot/agent/getAgentLoggedId'

function isAgentLogged() {
  return Boolean(getAgentLoggedId())
}

export default isAgentLogged
